/*
 * userQualificationLUCategory.dto.ts
 */
export type mtUserQualificationLUCategoryDto = {
  cpinID: number;
  cpidCreatedAt: Date;
  cpidUpdatedAt: Date;
  cpidDeletedAt: Date | null;
  //
  cpisCategory: string;
  cpisUX: string;
  cpisRemarks: string | null;
};
//
export type mtUserQualificationLUCategoryCreateDto = Omit<
  mtUserQualificationLUCategoryDto,
  'cpinID' | 'cpidCreatedAt' | 'cpidUpdatedAt' | 'cpidDeletedAt'
>;
//
export type mtUserQualificationLUCategoryUpdateDto = Omit<
  mtUserQualificationLUCategoryDto,
  'cpidCreatedAt' | 'cpidUpdatedAt' | 'cpidDeletedAt'
>;
//
export const moUserQualificationLUCategoryInit: mtUserQualificationLUCategoryDto = {
  cpinID: Date.now() * -1,
  cpidCreatedAt: new Date(),
  cpidUpdatedAt: new Date(),
  cpidDeletedAt: null,
  cpisCategory: 'eUNDEFINED',
  cpisUX: 'UNDEFINED',
  cpisRemarks: null,
};
//#end#
